import { UserDashboard } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.USERDASHBOARD.path,
      name: "Home",
      key: routesMap.USERDASHBOARD.path,
      commonRoute: false,
      private: true,
      withAuth: false,
      belongsToHeader: true,
      element: <UserDashboard />,
    },
  ];
}
